import React, {FC} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import GenericModal from "@irati/ui/src/GenericModal"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {Img} from "../styled"

interface Props extends InjectIntl {
  show: boolean
  onClose: () => void
}

const SuccessResponseModal: FC<Props> = ({show, onClose, formatMessage}) => {
  const theme = useTheme()

  return (
    <GenericModal customWidth={700} hideActions show={show} onHide={onClose}>
      <Flex justifyContent="center" padding={[6, 3, 3]}>
        <Img width="200px" src={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.responseModal.success.img"})} />
      </Flex>
      <H2 color={theme.colors.perkbox.greenBlue} marginBottom={2} paddingLeft={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.success.title" />
      </H2>
      <Body marginBottom={4} paddingLeft={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.success.subTitle" />
      </Body>
    </GenericModal>
  )
}

export default injectIntl(SuccessResponseModal)
